import { FALLBACK_TOP_SELF_CLOSE_PERCENT } from '~/constants/agentTiers';
import { LANDING_FACTS_TIMEOUT_MS } from '~/constants/landing';
import { topSelfClosePercentFrom } from '~/utils/landing/facts';

const TOP_SPLIT_PERCENT_KEY = 'top-split-percent';

const fetchTopSplitPercent = async (): Promise<number | null> => {
  try {
    const res = await $fetch<{ data?: unknown }>('/api/agent/commission-tiers', { timeout: LANDING_FACTS_TIMEOUT_MS });
    return topSelfClosePercentFrom(res?.data);
  } catch {
    return null;
  }
};

/**
 * Top self-close split (Elite) from the tier config, rendered on the server for "up to {percent}%" copy.
 * Falls back to the tier constants' top only when the config can't be read.
 */
export const useTopSplitPercent = () => {
  const { data } = useAsyncData<number | null>(TOP_SPLIT_PERCENT_KEY, fetchTopSplitPercent, { default: () => null });

  const percent = computed<number>(() => data.value ?? FALLBACK_TOP_SELF_CLOSE_PERCENT);

  return {
    percent,
  };
};
